import React, { useEffect, useState } from "react"
import { Box, Container } from "@mui/material"
import Tabs from "../components/Tabs/Tabs"
import { mdiCar, mdiWeb } from "@mdi/js"
import CountrySelection from "../components/CountrySelection"
import VehicleSelection from "./subpages/VehicleSelection"
import Button from "../../../components/Button"
import { useTranslation } from "react-i18next"
import ResponsiveBackground from "../../../components/ResponsiveBackground"
import { useTheme } from "@mui/material/styles"

const TecRMI = (props) => {
  const [isHomeSelected, setIsHomeSelected] = useState(false)
  const { t } = useTranslation("app")
  const theme = useTheme()

  const [step, setStep] = useState(0)

  useEffect(() => {
    if (isHomeSelected) setIsHomeSelected(false)
  }, [isHomeSelected])

  function backToHome() {
    setIsHomeSelected(true)
  }

  const handleStep = (value) => {
    setStep(step + value)
  }

  return (
    <ResponsiveBackground theme={theme}>
      <Container>
        <Tabs
          isHomeSelected={isHomeSelected}
          icons={[{ path: mdiCar }, { path: mdiWeb }]}
          labels={[{ label: "" }, { label: "" }]}
          components={[
            {
              element: <VehicleSelection step={step} handleStep={handleStep} />,
              hasPadding: true,
            },
            {
              element: <CountrySelection backToHome={backToHome} />,
              hasPadding: true,
            },
          ]}
          variant={"horizontal"}
        />
        {step === 0 ? (
          <Button path={"/"} text={t("back")} color={"primary"} />
        ) : (
          <Box onClick={() => handleStep(-1)}>
            <Button isDisabled={true} path={"/"} text={t("back")} color={"primary"} />
          </Box>
        )}
      </Container>
    </ResponsiveBackground>
  )
}

export default TecRMI
